import * as Sentry from '@sentry/react';

export const SentryService = {
  /**
   * Set user identifier for Sentry error tracking
   */
  setUserId: (userId: string) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Sentry] Setting user ID: ${userId}`);
    }
    Sentry.setUser({ id: userId });
  },

  /**
   * Set user context with stream user info
   */
  setUserContext: (userId: string) => {
    SentryService.setUserId(userId);
    Sentry.addBreadcrumb({
      message: `User context set for: ${userId}`,
      level: 'info',
      category: 'auth',
    });
  },

  /**
   * Clear user context (on logout)
   */
  clearUserContext: () => {
    Sentry.setUser(null);
    Sentry.addBreadcrumb({
      message: 'User context cleared',
      level: 'info',
      category: 'auth',
    });
  },

  /**
   * Set custom user attributes/tags
   */
  setUserAttributes: (attributes: Record<string, string>) => {
    Sentry.setTags(attributes);
  },

  /**
   * Add breadcrumb for user actions
   */
  addBreadcrumb: (message: string, category: string = 'user') => {
    Sentry.addBreadcrumb({
      message,
      level: 'info',
      category,
    });
  },
};

export default SentryService; 